define.alias("shared/components/shared/mobile/drawer/layout", "calendar/components/shared/mobile/drawer/layout");